import { useMutation, useQuery } from '@tanstack/react-query';

import {
  type WebhooksAddContent,
  WebhooksRequester,
  type WebhooksUpdateContent,
} from '@cobliteam/api-lib';

const webhooksRequester = new WebhooksRequester();

const WEBHOOKS_QUERY_KEY = 'webhooks';

const useWebhooks = () => {
  const getWebhooks = () => {
    return useQuery<WebhooksUpdateContent[]>({
      queryKey: [`${WEBHOOKS_QUERY_KEY}`],
      queryFn: () => webhooksRequester.getWebhooks(),
      retry: false,
      enabled: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    });
  };

  const createWebhooks = useMutation<
    string,
    unknown,
    { webhook: WebhooksAddContent }
  >({
    mutationFn: (webhookAddContent) =>
      webhooksRequester.generateNewWebhook(webhookAddContent.webhook),
  });

  const updateWebhooks = useMutation<
    string,
    unknown,
    { webhook: WebhooksUpdateContent }
  >({
    mutationFn: (webhookUpdateContent) =>
      webhooksRequester.updateWebhook(webhookUpdateContent.webhook),
  });

  const deleteWebhooks = useMutation<void, unknown, { id: string }>({
    mutationFn: (webhook) => webhooksRequester.revokeWebhooks(webhook.id),
  });

  return {
    getWebhooks,
    createWebhooks,
    updateWebhooks,
    deleteWebhooks,
  };
};

export default useWebhooks;
